export function regionCheck(data, region) {
	return (data?.includeRegions === null || data?.includeRegions?.includes(region)) &&
		(data?.excludeRegions === null || !data?.excludeRegions?.includes(region));
}

